import React from 'react';
import { Button, Form, FormGroup, FormControl, Col, Row, ButtonGroup, ToggleButton } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios';
import moment from 'moment';

import "react-day-picker/lib/style.css";
import 'moment/locale/sv';

import DayPickerInputWithAddon from '../../../DayPickerInputWithAddon'
import TimePicker from 'rc-time-picker';
import 'rc-time-picker/assets/index.css';

import constants from '../../../util/constants';
const { API_BASE_URL } = constants;

class BannerSettings extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            toggleRange: [
                { name: 'Active', value: 1 },
                { name: 'Inactive', value: 0 }
            ],
            bannerActive: 0,

            startDate: moment(new Date()).format('YYYY-MM-DD'),
            startTime: moment(),
            endDate: moment(new Date()).format('YYYY-MM-DD'),
            endTime: moment(),

            bannerText: '',
            bannerTextPlaceholder: 'Text to display inside the banner.',
        }

        this.axiosCancelSource = axios.CancelToken.source();
        this.apiOptions = { headers: { 'Authorization': 'Bearer ' + this.props.apiToken }, cancelToken: this.axiosCancelSource.token };

        this.toggleState = this.toggleState.bind(this)
        this.handleStartDate = this.handleStartDate.bind(this)
        this.handleEndDate = this.handleEndDate.bind(this)
        this.getBannerSettings = this.getBannerSettings.bind(this)
        this.updateBannerSettings = this.updateBannerSettings.bind(this)
    }

    componentDidMount() {
        this.getBannerSettings()
    }

    getBannerSettings() {
        const self = this;
        const getBannerSettings = 'Portal/GetBannerSettings';

        axios.get(API_BASE_URL + getBannerSettings)
            .then(res => {
                if (res?.data) {
                    const { BannerText, BannerActive, BannerStartDateTime, BannerEndDateTime } = res.data
  
                    self.setState({
                        bannerText: BannerText,
                        bannerActive: BannerActive,
                        startDate: moment(BannerStartDateTime).format('YYYY-MM-DD'),
                        startTime: moment(BannerStartDateTime),
                        endDate: moment(BannerEndDateTime).format('YYYY-MM-DD'),
                        endTime: moment(BannerEndDateTime)
                    })
                }
            })
            .catch(err => {
                console.error(err)
            });
    }

    updateBannerSettings() {
        const self = this;
        const updateBannerSettings = 'Portal/UpdateBannerSettings';

        let { startDate, startTime, endDate, endTime } = this.state

        // Get hour/minuites from timepicker
        startTime = startTime.format('HH:mm')
        endTime = endTime.format('HH:mm')

        // Merge date and time, and then format
        const startDateTime = moment(startDate + " " + startTime, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm')
        const endDateTime = moment(endDate + " " + endTime, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm')

        let bannerSettings = {
            BannerText: self.state.bannerText,
            BannerActive: self.state.bannerActive,
            BannerStartDateTime: startDateTime,
            BannerEndDateTime: endDateTime
        };

        axios.post(API_BASE_URL + updateBannerSettings, bannerSettings, self.apiOptions)
            .then(response => {
                sessionStorage.setItem('banner-hide', false);
                this.setState({
                    success: true,
                    successMessage: 'Banner settings successfully updated!'
                }, () => setTimeout(() => { this.setState({ success: false }) }, 5000));
            })
            .catch(err => {
                this.setState({
                    error: true,
                    errorMessage: 'Could not update banner settings, see console error.'
                }, () => setTimeout(() => { this.setState({ error: false }) }, 5000))
            })
    }

    toggleState(state, item) {
        this.setState({
            [state]: item
        })
    }

    handleStartDate(momentValue) {
        let startDate = momentValue && momentValue.format('YYYY-MM-DD')
        this.setState({
            'startDate': startDate
        }, () => console.log(this.state.startDate))
    }

    handleEndDate(momentValue) {
        let endDate = momentValue && momentValue.format('YYYY-MM-DD')
        this.setState({
            'endDate': endDate
        })
    }

    render() {
        const { toggleRange, bannerActive, startDate, startTime, endDate, endTime, bannerText, bannerTextPlaceholder } = this.state
        return (
            <div className="create-user">
                <section>
                    <div className="center-block text-center user-heading"> Banner Settings </div>
                    <Form horizontal >
                        <section>
                            <FormGroup controlId="formHorizontalCSM" bsSize="small">
                                <Row>
                                    <Col sm={2}>
                                        <label>Toggle banner</label>
                                        <ButtonGroup className="np-radio-wrapper" toggle="toggle">
                                            {toggleRange.map((radio, idx) => (
                                                <ToggleButton
                                                    key={idx}
                                                    type="radio"
                                                    variant="secondary"
                                                    name="radio"
                                                    value={radio.value}
                                                    checked={bannerActive === radio.value}
                                                    className={bannerActive == radio.value ? 'active' : ''}
                                                    onChange={(e) => this.toggleState("bannerActive", e.target.value)}
                                                >
                                                    {radio.name}
                                                </ToggleButton>
                                            ))}
                                        </ButtonGroup>
                                    </Col>
                                    <Col sm={5}>
                                        <label>Start time</label>
                                        <Row>
                                            <Col sm={8}>
                                                <DayPickerInputWithAddon
                                                    value={startDate}
                                                    label="From"
                                                    width="100%"
                                                    placeholder="YYYY MM DD"
                                                    onChange={(newDate) => this.handleStartDate(newDate)} />
                                            </Col>
                                            <Col sm={4}>
                                                <TimePicker
                                                    value={startTime}
                                                    minuteStep={15}
                                                    showSecond={false}
                                                    placeholder="--:--"
                                                    clearIcon={(<FontAwesomeIcon icon={faTimes} />)}
                                                    onChange={(newTime) => this.toggleState("startTime", newTime)} />
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col sm={5}>
                                        <label>End time</label>
                                        <Row>
                                            <Col sm={8}>
                                                <DayPickerInputWithAddon
                                                    value={endDate}
                                                    label="To"
                                                    width="100%"
                                                    placeholder="YYYY MM DD"
                                                    onChange={(newDate) => this.handleEndDate(newDate)} />
                                            </Col>
                                            <Col sm={4}>
                                                <TimePicker
                                                    value={endTime}
                                                    minuteStep={15}
                                                    showSecond={false}
                                                    placeholder="--:--"
                                                    clearIcon={(<FontAwesomeIcon icon={faTimes} />)}
                                                    onChange={(newTime) => this.toggleState("endTime", newTime)} />

                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row className="margin-top-10">
                                    <Col sm={2}></Col>
                                    <Col sm={10}>
                                        <label>Banner text</label>
                                        <FormControl type="text" placeholder={bannerTextPlaceholder} value={bannerText} onChange={(e) => this.toggleState("bannerText", e.target.value)}></FormControl>
                                    </Col>
                                </Row>
                                <Row className="margin-top-10">
                                    <Col sm={12}>
                                        {this.state.success &&
                                            <div>
                                                <label>{this.state.successMessage}</label>
                                            </div>
                                        }
                                        {this.state.showError &&
                                            <div>
                                                <label className="danger">{this.state.errorMessage}</label>
                                            </div>
                                        }
                                        <Button bsStyle="primary" className="margin-left-10 pull-right" onClick={this.updateBannerSettings}>Save banner settings</Button>
                                    </Col>
                                </Row>
                            </FormGroup>
                        </section>
                    </Form>
                </section>

            </div>
        );
    }
}
export default BannerSettings;